import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SessionCountdownService } from '../../../core/auth/services/session-countdown.service';

export interface BreadcrumbLevel {
  label: string;
  route?: string;
  state?: Record<string, unknown>;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  private readonly sessionCountdown = inject(SessionCountdownService);

  prefixLabel = input('AZ Translate Vendor Translations');
  shortPrefixLabel = input('AZT Home');
  baseRoute = input('/home');
  levels = input<BreadcrumbLevel[]>([]);
  readonly remainingTimeText = this.sessionCountdown.remainingTimeText;

  readonly breadcrumbLevels = computed<BreadcrumbLevel[]>(() => {
    return this.levels();
  });
}
